import dayjs from 'dayjs';

import { TicketSettingsFormValues } from '../TicketSettingsForm';

import { TicketModel } from 'v2/types/TicketModel';

export const getTicketEditFormValuesFromModel = (ticket: TicketModel): TicketSettingsFormValues => {
  const { id, date, details, ...restFields } = ticket;

  return { ...restFields, date: dayjs(date), details: details ?? '' };
};
